var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['search-result-loading', !_vm.isPC && 'search-result-loading-h5']},[_c('Loading',{attrs:{"width":"40px","height":"40px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }